import React from 'react';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import clsx from 'clsx';
import LoadingSpinner from 'components/LoadingSpinner';
import Tooltip from 'components/Tooltip';
import Checkbox from 'components/V2/Checkbox';
import PropTypes from 'prop-types';
import { prepareListingsTableHeader } from 'views/V2/Integration/utils';

import styles from './listingTable.module.css';

import TableHeaderInfo from '../TableHeaderInfo';

const HEADER_LABELS = ['Brand', 'Listing Name', 'Address'];

const ListingTable = (props) => {
    const {
        rows,
        isFetching,
        scrollContainerRef,
        onScroll,
        totalCount,
        filteredListings,
        handleFilterListings,
        onSelectAll,
        onClearSelection,
    } = props;

    const header = prepareListingsTableHeader(HEADER_LABELS);
    const selectedIdSet = new Set((filteredListings || []).map(String));
    const isAllSelected = rows.length > 0 && rows.every((row) => filteredListings.includes(row.id));

    const handleSelectAllToggle = () => {
        if (isAllSelected) {
            onClearSelection?.();
        } else {
            onSelectAll?.();
        }
    };

    return (
        <TableContainer
            ref={scrollContainerRef}
            onScroll={onScroll}
            className={styles.tableContainer}
        >
            <Table stickyHeader>
                <TableHead className={styles.tableHeader}>
                    <TableHeaderInfo
                        totalCount={totalCount}
                        rows={rows}
                        filteredListings={filteredListings}
                    />
                    <TableRow>
                        <TableCell className={styles.tableHeadCell}>
                            <Tooltip title="Select all visible listings" arrow placement="right">
                                <span>
                                    <Checkbox
                                        checked={isAllSelected}
                                        onChange={handleSelectAllToggle}
                                    />
                                </span>
                            </Tooltip>
                        </TableCell>
                        {header.map((item) => (
                            <TableCell key={item.id} className={styles.tableHeadCell}>
                                {item.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.id} className={row.enabled ? '' : styles.disabledRow}>
                            <TableCell>
                                <Checkbox
                                    checked={selectedIdSet.has(String(row.id))}
                                    onChange={() => handleFilterListings(row.id)}
                                />
                            </TableCell>
                            <TableCell className={clsx(styles.tableBodyCell, styles.brandName)}>
                                {row.brand}
                            </TableCell>
                            <TableCell className={clsx(styles.tableBodyCell, styles.listingName)}>
                                {row.name}
                            </TableCell>
                            <TableCell className={clsx(styles.tableBodyCell, styles.address)}>
                                {row.address}
                            </TableCell>
                        </TableRow>
                    ))}
                    {isFetching && rows.length > 0 && (
                        <TableRow>
                            <TableCell
                                colSpan={HEADER_LABELS.length + 1}
                                className={styles.loadingCell}
                                align="center"
                            >
                                <LoadingSpinner />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

ListingTable.propTypes = {
    rows: PropTypes.array,
    isFetching: PropTypes.bool,
    scrollContainerRef: PropTypes.object,
    onScroll: PropTypes.func,
    totalCount: PropTypes.number,
    filteredListings: PropTypes.array,
    handleFilterListings: PropTypes.func,
    onSelectAll: PropTypes.func,
    onClearSelection: PropTypes.func,
};

export default ListingTable;
